import { IhostspotRequest, IhostspotResponse } from '../../types/hotspot';

const staticConfig = {
    type: 'disc',
    discOption: {
        radius: 0.015
    },
    texture: {
        type: 1,
        url: 'https://static-assets-web.flixcart.com/batman-returns/batman-returns/p/images/logo_lite-cbb357.png'
    }
};

export const initViewerConfig = (data: any, modelUrl: string) => {
    let payload = {};

    if (data.hotspotCardMap) {
        for (const key in data.hotspotCardMap) {
            payload[key] = {
                position: {
                    x: Number(data.hotspotCardMap[key].position.x),
                    y: Number(data.hotspotCardMap[key].position.y),
                    z: Number(data.hotspotCardMap[key].position.z),
                    _isDirty: true
                },
                camera: {
                    alpha: Number(data.hotspotCardMap[key].alpha),
                    beta: Number(data.hotspotCardMap[key].beta),

                    target: {
                        x: Number(data.hotspotCardMap[key].target.x),
                        y: Number(data.hotspotCardMap[key].target.y),
                        z: Number(data.hotspotCardMap[key].target.z),
                        _isDirty: true
                    },
                    radius: Number(data.hotspotCardMap[key].radius)
                },
                ...staticConfig
            };
        }
    } else if (data.productHotspotCardMap) {
        for (const key in data.productHotspotCardMap) {
            console.log('key:', key);
            payload[key] = {
                position: {
                    x: Number(data.productHotspotCardMap[key].position.x),
                    y: Number(data.productHotspotCardMap[key].position.y),
                    z: Number(data.productHotspotCardMap[key].position.z),
                    _isDirty: true
                },
                camera: {
                    alpha: Number(data.productHotspotCardMap[key].alpha),
                    beta: Number(data.productHotspotCardMap[key].beta),

                    target: {
                        x: Number(data.productHotspotCardMap[key].target.x),
                        y: Number(data.productHotspotCardMap[key].target.y),
                        z: Number(data.productHotspotCardMap[key].target.z),
                        _isDirty: true
                    },
                    radius: Number(data.productHotspotCardMap[key].radius)
                },
                ...staticConfig
            };
        }
    }

    const viewerCommand = {
        requestId: 23501,
        command: 'initViewer',
        config: {
            model: {
                url: modelUrl
            },
            ground: null,
            doubleClickEvent: true,
            clickEvent: true,
            camera: {
                behaviors: {
                    autoRotate: false
                }
            },
            spriteManagerConfig: {
                name: 'spriteManager',
                imgUrl: 'https://rukminim1.flixcart.com/www/50/50/promos/05/12/2022/f40b64e2-98e4-40d2-bc0e-f66cf8b12d37.png?q=90',
                capacity: 100,
                cellSize: 50
            },
            meshConfigurator: {
                customMeshConfig: payload,
                onRotateHotspotVisibility: {
                    type: 'disc',
                    isVisible: true,
                    alpha: 0.4
                }
            }
        }
    };
    return viewerCommand;
};

export const updateViewer = (data: IhostspotRequest, fsn: string, id: string, isLite?: boolean | false) => {
    let texture;
    let discOption;
    if (isLite) {
        discOption = {
            radius: 0.015
        };
        texture = {
            type: 0,
            url: 'https://static-assets-web.flixcart.com/batman-returns/batman-returns/p/images/logo_lite-cbb357.png'
        };
    } else {
        discOption = {
            radius: 0.015
        };
        texture = {
            type: 1,
            url: 'https://rukminim1.flixcart.com/www/1560/120/promos/02/02/2023/79206e53-9772-484b-9e24-95bb47a81b1f.png?q=100'
        };
    }

    let payload = {
        type: 'disc',
        discOption: discOption,
        texture: texture,
        position: {
            x: Number(data.position.x),
            y: Number(data.position.y),
            z: Number(data.position.z)
        },
        camera: {
            target: {
                x: Number(data.target.x),
                y: Number(data.target.y),
                z: Number(data.target.z),
                _isDirty: true
            },
            alpha: Number(data.alpha),
            beta: Number(data.beta),
            radius: Number(data.radius)
        }
    };

    const updateCommand = {
        requestId: 23501,
        command: 'Update',
        config: {
            meshConfigurator: {
                customMeshConfig: {
                    [id]: payload
                }
            }
        }
    };
    return updateCommand;
};

export const deleteHotspotConfig = (id: string) => {
    const deleteConfig = {
        requestId: 23501,
        command: 'Update',
        config: {
            meshConfigurator: {
                hotspotBehaviour: {
                    [id]: 0
                }
            }
        }
    };
    return deleteConfig;
};

export const viewHotspotConfig = (data: IhostspotResponse) => {
    const config = {
        requestId: 23501,
        command: 'Update',
        config: {
            camera: {
                alpha: Number(data.alpha),
                beta: Number(data.beta),
                target: {
                    x: Number(data.target.x),
                    y: Number(data.target.y),
                    z: Number(data.target.z),
                    _isDirty: true
                },
                radius: Number(data.radius)
            }
        }
    };
    return config;
};

export const captureRotationConfig = () => {
    const config = {
        requestId: 23501,
        command: 'captureRotationConfig',
        config: {}
    };
    return config;
};

export const updateViewerConfig = (modelUrl: string) => {
    const viewerCommand = {
        requestId: 23501,
        command: 'Update',
        config: {
            model: {
                url: modelUrl
            }
        }
    };
    return viewerCommand;
};

export const updateCamera = (data: any) => {
    const viewerCommand = {
        requestId: 23501,
        command: 'Update',
        config: {
            camera: data
        }
    };
    return viewerCommand;
};
